import _ from 'underscore';
import SoundLibrary from '../utils/sound/SoundLibrary';

/////////////////////////////////////////////////////////////////////////
// CONSTRUCTOR //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const GameSounds = _.extend( Object.create(SoundLibrary), {
	
	SOUND_BUTTON_PRESS: 'SOUND_BUTTON_PRESS',
	SOUND_BALL_HIT1: 'SOUND_BALL_HIT1',
  SOUND_BALL_HIT2: 'SOUND_BALL_HIT2',
  SOUND_BALL_HIT3: 'SOUND_BALL_HIT3',
	SOUND_BALL_HOPPER: 'SOUND_BALL_HOPPER',
	SOUND_TRAY_FILL: 'SOUND_TRAY_FILL',
	SOUND_IN_HOLE: 'SOUND_IN_HOLE',
  SOUND_HIT_RAMP: 'SOUND_HIT_RAMP',
	SOUND_ROLL_DOWN: 'SOUND_ROLL_DOWN',
  SOUND_SMALL_WIN: 'SOUND_SMALL_WIN',
  SOUND_MEDIUM_WIN: 'SOUND_MEDIUM_WIN',
  SOUND_BIG_WIN: 'SOUND_BIG_WIN',
  SOUND_EXTRA_BALL: 'SOUND_EXTRA_BALL',
  SOUND_BONUS_TURNS: 'SOUND_BONUS_TURNS',
  SOUND_BALL_CLACK: 'SOUND_BALL_CLACK',
  SOUND_GLITTER_AIR: 'SOUND_GLITTER_AIR',
  SOUND_GAME_OVER: 'SOUND_GAME_OVER',

	MUSIC_LOOP: 'MUSIC_LOOP',
	MUSIC_END: 'MUSIC_END',
	BONUS_MUSIC_LOOP: 'BONUS_MUSIC_LOOP',
	BONUS_MUSIC_END: 'BONUS_MUSIC_END',

	initLibrary: function(game) {

		this.init(game);

		this._musicVolume = 0.1;

		this.sounds[GameSounds.MUSIC_LOOP] = {path: 'BonusWheel_MUSIC_LOOP', loop: true, volume: this.musicVolume};
		this.sounds[GameSounds.MUSIC_END] = {path: 'BonusWheel_MUSIC_END', volume: this.musicVolume};

    this.sounds[GameSounds.SOUND_BUTTON_PRESS] = {path: 'blip'};
		this.sounds[GameSounds.SOUND_BALL_HIT1] = {path: 'ballHit1'};
    this.sounds[GameSounds.SOUND_BALL_HIT2] = {path: 'hit'};
    this.sounds[GameSounds.SOUND_BALL_HIT3] = {path: 'hit2'};
		this.sounds[GameSounds.SOUND_BALL_HOPPER] = {path: 'ballHopper'};
		this.sounds[GameSounds.SOUND_TRAY_FILL] = {path: 'balltrayFill'};
		this.sounds[GameSounds.SOUND_HIT_RAMP] = {path: 'snare'};
		this.sounds[GameSounds.SOUND_IN_HOLE] = {path: 'inHole'};
		this.sounds[GameSounds.SOUND_RAMP] = {path: 'Skeeballthrowroll'};
		this.sounds[GameSounds.SOUND_ROLL_DOWN] = {path: 'rolldown'};
    this.sounds[GameSounds.SOUND_SMALL_WIN] = {path: 'Bells', volume: 0.3};
    this.sounds[GameSounds.SOUND_MEDIUM_WIN] = {path: 'beeda_loo'};
    this.sounds[GameSounds.SOUND_BIG_WIN] = {path: 'BigWin', volume: 0.6};
    this.sounds[GameSounds.SOUND_EXTRA_BALL] = {path: 'extraBall'};
    this.sounds[GameSounds.SOUND_BONUS_TURNS] = {path: 'ArcadeWin', volume: 0.3};
    this.sounds[GameSounds.SOUND_GAME_OVER] = {path: 'failSound'};
    this.sounds[GameSounds.SOUND_GLITTER_AIR] = {path: 'GlitterAir'};

		/*
		this.sounds[GameSounds.SOUND_COINS_DROP] = {path: 'Coins_1_FD'};
		this.sounds[GameSounds.SOUND_ENTER_FREE_SPINS] = {path: 'BlueFlames_1_FD'};
		this.sounds[GameSounds.SOUND_DICE_LAND] = {path: 'Kung Fu Start'};
		this.sounds[GameSounds.SOUND_BONUS_DICE_PICK] = {path: 'Kung Fu Open'};
		this.sounds[GameSounds.SOUND_BONUS_WIN] = {path: 'China Menu Award'};
		this.sounds[GameSounds.SOUND_BUTTON_CLICK1] = {path: 'Button Click'};
		this.sounds[GameSounds.SOUND_MATCH_WILD] = {path: 'China Menu Reveal'};
		*/


		return this;
	}

});

export default GameSounds;







// WEBPACK FOOTER //
// ./app/src/sound/GameSounds.js